module.exports = __webpack_public_path__ + "static/media/copy.74dbf4ca.png";